import { Box, Typography, Switch } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

const parseTimeString = (timeString) => {
  if (typeof timeString !== 'string' || !timeString) return null;
  const [hours, minutes] = timeString.split(':').map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0, 0);
  return date;
};

const formatTimeString = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return null;
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  return `${hours}:${minutes}:00`;
};

const WorkdayHours = ({ name, data, onChange, error }) => {
  const { isOpened = false, open = null, close = null } = data || {};

  const handleToggleChange = (event) => {
    onChange({
      isOpened: event.target.checked,
      open: null,
      close: null,
    });
  };

  const handleTimeChange = (key, value) => {
    onChange({
      ...data,
      [key]: value ? formatTimeString(value) : null,
    });
  };

  return (
    <Box className="flex flex-col gap-8 mb-6">
      <Box className="flex items-center">
        <Typography component="label" className="capitalize min-w-80 font-500 opacity-90">
          {name}
        </Typography>
        <Switch checked={isOpened} onChange={handleToggleChange} />
      </Box>

      {isOpened && (
        <Box className="flex flex-col">
          <Box style={{ display: 'flex', flexGrow: 1, alignItems: 'center', gap: '10px' }}>
            <TimePicker
              sx={{ flex: 1 }}
              label="Open"
              value={parseTimeString(open)}
              onChange={(newValue) => handleTimeChange('open', newValue)}
              localeText={{
                fieldHoursPlaceholder: () => '--',
                fieldMinutesPlaceholder: () => '--',
                fieldMeridiemPlaceholder: () => 'AM/PM',
              }}
              slotProps={{
                textField: {
                  error: !!error && !open,
                },
              }}
            />
            <TimePicker
              sx={{ flex: 1 }}
              label="Close"
              value={parseTimeString(close)}
              onChange={(newValue) => handleTimeChange('close', newValue)}
              localeText={{
                fieldHoursPlaceholder: () => '--',
                fieldMinutesPlaceholder: () => '--',
                fieldMeridiemPlaceholder: () => 'AM/PM',
              }}
              slotProps={{
                textField: {
                  error: !!error && !close,
                },
              }}
            />
          </Box>
          {error && (!open || !close) && (
            <Typography className="text-12 text-red-600 mt-4">{error}</Typography>
          )}
        </Box>
      )}
      </Box>
  );
};

export default WorkdayHours;
